export function setStorage (key: string, value: any) {
  localStorage.setItem(key, JSON.stringify(value))
}

export function getStorage (key: string) {
  const value = localStorage.getItem(key)
  try {
    return JSON.parse(value as string)
  } catch (e) {
    return value
  }
}

export function removeStorage (key: string) {
  localStorage.removeItem(key)
}

export function clearStorage () {
  localStorage.clear()
}
